module.exports = __webpack_public_path__ + "static/img/ting-jun-yixi-hua.8901c4c2.png";